/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface PtwSessionDto
 */
export interface PtwSessionDto {
    /**
     * 
     * @type {number}
     * @memberof PtwSessionDto
     */
    tenantId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PtwSessionDto
     */
    userId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwSessionDto
     */
    userName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwSessionDto
     */
    isFirstTimeInstallation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PtwSessionDto
     */
    isInstallationActivated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PtwSessionDto
     */
    isLicenseValid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PtwSessionDto
     */
    licenseExpirationDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwSessionDto
     */
    companyId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PtwSessionDto
     */
    ipin?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwSessionDto
     */
    $type?: PtwSessionDtoTypeEnum;
}


/**
 * @export
 */
export const PtwSessionDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationAccountDtoPtwSessionDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Account.Dto.PtwSessionDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PtwSessionDtoTypeEnum = typeof PtwSessionDtoTypeEnum[keyof typeof PtwSessionDtoTypeEnum];



/**
 * Check if a given object implements the PtwSessionDto interface.
 */
export function instanceOfPtwSessionDto(value?: unknown): value is PtwSessionDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PtwSessionDtoTypeEnum)[0];
}

export function PtwSessionDtoFromJSON(json: any): PtwSessionDto {
    return PtwSessionDtoFromJSONTyped(json, false);
}

export function PtwSessionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtwSessionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'isFirstTimeInstallation': json['isFirstTimeInstallation'] == null ? undefined : json['isFirstTimeInstallation'],
        'isInstallationActivated': json['isInstallationActivated'] == null ? undefined : json['isInstallationActivated'],
        'isLicenseValid': json['isLicenseValid'] == null ? undefined : json['isLicenseValid'],
        'licenseExpirationDate': json['licenseExpirationDate'] == null ? undefined : json['licenseExpirationDate'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'ipin': json['ipin'] == null ? undefined : json['ipin'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function PtwSessionDtoToJSON(value?: PtwSessionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'tenantId': value['tenantId'],
        'userId': value['userId'],
        'userName': value['userName'],
        'isFirstTimeInstallation': value['isFirstTimeInstallation'],
        'isInstallationActivated': value['isInstallationActivated'],
        'isLicenseValid': value['isLicenseValid'],
        'licenseExpirationDate': value['licenseExpirationDate'],
        'companyId': value['companyId'],
        'ipin': value['ipin'],
        '$type': value['$type'],
    });
}

